(function($) {

var $paginationHolder = $('.listing-pagination'),
    $categoryFilter = $('#cat-filters'),
    $resultsList = $('#post-items');

/**
 * Pagination Functions:
 * Triggers ajax pagination via gatherVars().
**/
$paginationHolder.on('click', 'a', function(e) {
    e.preventDefault();

    gatherVars($(this).text());
});

/**
 * Filter Functions: 
 * Sets selected option to active, adjusts dropdown label to selected option, closes
 * dropdown, and triggers ajax call via gatherVars().
**/ 
$categoryFilter.on('click', 'a', function(e) {
    e.preventDefault();

    if($(this).parent('li').hasClass('active')) {
        return;
    } else {
        $categoryFilter.find('li.active').removeClass('active');
        $(this).parent('li').addClass('active');
    }

    gatherVars(1);
});

// Gather currently selected filters options and triggers ajax call.
function gatherVars(page = 1) {
    var category = $categoryFilter.find('li.active a').data('cat');

    triggerFilter(category, page);
}

/**
 * Will trigger the ajax call to get current posts to display, sets pagination display, 
 * sets new filter options based on availabed taxonomies, and set display of reset button.
**/
function triggerFilter(category = "", page = 1) {
    $.post(ajax_global.url, {
        action: "post_filter",
        category: category,
        page: page
    }).done(function(r) {
        
        if (r.success) {
            // console.log(r.data);
            pagination = r.data.pagination;
            posts = r.data.posts;
            catName = r.data.catName;
            
            $('#post-listing-name').html(catName);
            $resultsList.html(posts);
            $paginationHolder.each(function() {
                $(this).html(pagination);
            });
            
            
        } else {
            // console.log(r);
        }
    });
}

}(jQuery));